/* beautiful-react-hooks version: 0.35.0 */
import { useRef, useEffect } from 'react';

var distinctValues = function distinctValues(value, current, array) {
  return array.indexOf(value) === current;
};

var useValueHistory = function useValueHistory(value) {
  var distinct = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var history = useRef([]);
  useEffect(function () {
    history.current.push(value);

    if (distinct) {
      history.current.filter(distinctValues);
    }
  }, [value]);
  return history.current;
};

export default useValueHistory;
